// Footer hold to sentence : a-Developed to Tech4Life(https://tech4lifebs.com/en/home/) b-Powered by @ OTS
import React, { Component } from 'react';
import { connect } from 'react-redux';

import './footer.css'

class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            smallScreen: false
        };
    }

    UNSAFE_componentWillMount() {
        if (window.innerWidth < 766) {
            this.setState({ smallScreen: true, flag: false })
        }
    }


    render() {
        let open = this.props.IsOpen
        return (
            <div className="footer" style={{ display: this.state.smallScreen ? "block" : "flex", width: this.state.smallScreen ? "100vw" : open ? "82vw" : "94vw", transition: "all 0.6s ease", margin: this.props.lang === 'en' ? "0 20px 0 auto" : "0 auto 0 20px" }}>
                <div className="mb-1">
                    powered by @ &nbsp;
                 <span className="sector1">O</span><span className="sector2">t</span><span className="sector3">S</span>
                </div>
                <div>
                    Developed to &nbsp;
                     <a href="https://tech4lifebs.com/" target="_blank" rel="noopener noreferrer" style={{ fontSize: "1.5rem" }}>
                        <span className="part">Tech</span><span className="part2">4</span><span className="part">Life</span>
                    </a>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        lang: state.userInfo.language,

    }
}

export default connect(mapStateToProps)(Footer);
